import { getKyClient } from './client';

export const fetchSuspensionRules = async () => {
  let url = `v1/FacilityAccountSuspensionRule`;

  const kyClient = await getKyClient();
  return kyClient.get(url).json();
};

export const fetchSuspensionRule = async (facilityAccountId) => {
  let url = `v1/FacilityAccountSuspensionRule/${facilityAccountId}`;

  const kyClient = await getKyClient();
  return kyClient.get(url).json();
};

export const updateSuspensionRule = async ({
  facilityAccountId,
  fee,
  duration,
}) => {
  let url = `v1/FacilityAccountSuspensionRule`;
  const kyClient = await getKyClient();
  return kyClient.post(url, {
    json: { facilityAccountId, fee, duration },
  });
};
